import { IconChevronLeft } from '@tabler/icons-react-native';
import { Button } from 'app/design/primitives/button';
import { useNavigation } from 'app/hooks/navigation';
import { createTheme as createDSTheme } from 'app/shopify';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

const theme = createDSTheme();

export function HeaderLeftBack() {
  const navigation = useNavigation();
  return (
    <Button onPress={() => navigation.goBack()}>
      <IconChevronLeft strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['white-label.header.on-header']} />
    </Button>
  );
}
